import React from 'react'

export default function SpDashboardHome() {
  return (
    <div>
      Dashboard
    </div>
  )
}
